import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { Position, useNodeConnections, useReactFlow } from '@xyflow/react';

export const getSourceHandleKey = (position, id) => 'source' + '_' + position + '_' + id;
export const getTargetHandleKey = (position, id) => 'target' + '_' + position + '_' + id;

export const useSourceHandle = (pos, id) => useMemo(() => getSourceHandleKey(pos, id), []);
export const useTargetHandle = (pos, id) => useMemo(() => getTargetHandleKey(pos, id), []);

export const getTargetHandlePosition = targetHandle => targetHandle.split('_')[1];

// Determine if the usual "source on right and target on left" assumption holds
// If so, then return the usual target position
export const isLeftTargetHandlePosition = (from, node) => {
  const { x } = node;

  const { x: fromX } = from;
  const leftX = x;
  return fromX <= leftX;
};

// Otherwise, check where the connection is going in order to determine
// which of the top or bottom is closer, then return that
export const getClosestVerticalTargetHandlePosition = (to, node) => {
  const { y, height } = node;

  const { y: toY } = to;
  const topY = y;
  const bottomY = y + height;

  if (toY <= topY) {
    return Position.Top;
  } else if (bottomY <= toY) {
    return Position.Bottom;
  }
  return null;
};
